import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const MenuDialog = (props) => {
    const { select_menu, handleClose } = props;
    // const dispatch = useDispatch();

    const [fullWidth, setFullWidth] = React.useState(true);

    return (
        <React.Fragment>
            <Dialog fullWidth={fullWidth} maxWidth="md" open={select_menu ? true : false} onClose={handleClose}>
                <DialogTitle sx={{ pr: 5 }}>
                    {select_menu.menu_name}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 1,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        noValidate
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            m: "auto",
                            width: "fit-content",
                        }}
                    >
                        <img src={select_menu.main_image_path} width="100%" />
                    </Box>

                    <Typography variant="h6" component="div" sx={{mt: 2}}>
                        料理内容
                    </Typography>
                    <DialogContentText style={{ whiteSpace: "pre-wrap" }}>{select_menu.dishes}</DialogContentText>
                    
                    <Typography variant="h6" component="div" sx={{mt: 2}}>
                        詳細
                    </Typography>
                    <DialogContentText style={{ whiteSpace: "pre-wrap" }}>{select_menu.description}</DialogContentText>

                    <Typography variant="h6" component="div" sx={{mt: 2}}>
                        提供期間
                    </Typography>
                    <DialogContentText>{select_menu.order_start_date}～{select_menu.order_end_date}</DialogContentText>         

                    {select_menu?.image_list?.length > 0 &&
                        <>
                            <Typography variant="h6" component="div" sx={{mt: 2}}>
                                商品イメージ
                            </Typography>
                            {select_menu?.image_list.map((image_data, index) => (
                                <React.Fragment key={index}>
                                    <Box
                                        noValidate
                                        sx={{
                                            width: "48%",
                                            display: "inline-block",
                                            margin: "1%",
                                            borderRadius: "1rem",
                                        }}
                                    >
                                        <img src={image_data.image_path} width="100%" className="radius-image" />
                                    </Box>
                                </React.Fragment>
                            ))}
                        </>
                    }
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default MenuDialog;
